import commonTitle from '@/components/Common/commonTitle'
  export default {
    install(Vue) {
        let componentList=[commonTitle]
        componentList.forEach(item=>{
          Vue.component(item.name, item)
        })
    }
  }